{{#with attributes}}
<span class="image-atom-{{../cid}}">
  <picture>
    <img src="{{path}}"
    {{#if height}}height="{{height}}"{{/if}}
    {{#if width}}width="{{width}}"{{/if}}
    alt="{{t sr-text.locale-key}}">
  </picture>
</span>
{{/with}}